import AdminCrudPage from "./AdminCrudPage";

export function AdminCourses() {
  return <AdminCrudPage title="Courses" endpoint="courses" testIdPrefix="courses"
    columns={[
      { key: "title", label: "Title" },
      { key: "category", label: "Category" },
      { key: "duration", label: "Duration" },
      { key: "fees", label: "Fees" },
      { key: "published", label: "Published", render: (i) => i.published ? "Yes" : "No" },
    ]}
    fields={[
      { name: "title", label: "Title", type: "text", required: true },
      { name: "slug", label: "Slug (url-friendly)", type: "text", required: true },
      { name: "subtitle", label: "Subtitle", type: "text" },
      { name: "tagline", label: "Tagline / hook line", type: "text" },
      { name: "category", label: "Category", type: "text", required: true },
      { name: "duration", label: "Duration", type: "text", required: true, placeholder: "e.g. 2 Months" },
      { name: "fees", label: "Fees", type: "text", required: true, placeholder: "e.g. ₹25,000" },
      { name: "trainer", label: "Trainer", type: "text" },
      { name: "learning_mode", label: "Learning mode", type: "text", default: "Online Live" },
      { name: "thumbnail", label: "Thumbnail URL", type: "url" },
      { name: "banner", label: "Banner URL (course detail page)", type: "url" },
      { name: "demo_video", label: "Demo video URL (YouTube embed)", type: "url" },
      { name: "brochure_url", label: "Brochure URL", type: "url" },
      { name: "syllabus_pdf", label: "Syllabus PDF URL", type: "url" },
      { name: "purchase_url", label: "Post-enrollment redirect URL (per course — fallback: Student Signup URL from Settings)", type: "url" },
      { name: "registration_url", label: "Registration URL", type: "url" },
      { name: "lms_url", label: "External LMS URL", type: "url" },
      { name: "description", label: "Short description", type: "textarea", required: true },
      { name: "overview", label: "Overview (long form, shown on Curriculum tab)", type: "textarea", rows: 6 },
      { name: "curriculum", label: "Curriculum quick-list (comma-separated)", type: "array-text" },
      { name: "modules", label: "Modules (JSON: [{\"title\":\"Module 1: ...\",\"duration\":\"Week 1\",\"topics\":[\"...\"]}])", type: "json", rows: 12, placeholder: '[\n  {"title":"Module 1: Intro","duration":"Week 1","topics":["Topic A","Topic B"]}\n]' },
      { name: "outcomes", label: "Learning outcomes (comma-separated)", type: "array-text" },
      { name: "tools", label: "Tools covered (comma-separated)", type: "array-text" },
      { name: "target_audience", label: "Target audience (comma-separated)", type: "array-text" },
      { name: "highlights", label: "Highlights / badges (comma-separated)", type: "array-text" },
      { name: "features", label: "Features (comma-separated)", type: "array-text" },
      { name: "projects", label: "Projects (comma-separated)", type: "array-text" },
      { name: "certification", label: "Certification info", type: "text" },
      { name: "published", label: "Published", type: "checkbox", default: true },
      { name: "featured", label: "Featured on homepage", type: "checkbox" },
      { name: "total_seats", label: "Total seats", type: "number", default: 0 },
      { name: "seats_left", label: "Seats left", type: "number", default: 0 },
      { name: "enrollment_deadline", label: "Enrollment deadline (YYYY-MM-DD)", type: "text", placeholder: "2026-04-15" },
      { name: "show_urgency", label: "Show seats-left urgency", type: "checkbox" },
    ]}
  />;
}

export function AdminBlogs() {
  return <AdminCrudPage title="Blogs" endpoint="blogs" testIdPrefix="blogs"
    columns={[
      { key: "title", label: "Title" },
      { key: "category", label: "Category" },
      { key: "author", label: "Author" },
      { key: "published", label: "Published", render: (i) => i.published ? "Yes" : "No" },
    ]}
    fields={[
      { name: "title", label: "Title", type: "text", required: true },
      { name: "slug", label: "Slug", type: "text", required: true },
      { name: "category", label: "Category", type: "text", required: true, default: "General" },
      { name: "author", label: "Author", type: "text", default: "EQtech Team" },
      { name: "featured_image", label: "Featured image URL", type: "url" },
      { name: "excerpt", label: "Excerpt", type: "textarea", rows: 2, required: true },
      { name: "content", label: "Content (Markdown supported — # headings, **bold**, lists, links)", type: "textarea", rows: 12, required: true },
      { name: "tags", label: "Tags (comma-separated)", type: "array-text" },
      { name: "meta_title", label: "Meta title", type: "text" },
      { name: "meta_description", label: "Meta description", type: "textarea", rows: 2 },
      { name: "published", label: "Published", type: "checkbox", default: true },
    ]}
  />;
}

export function AdminTestimonials() {
  return <AdminCrudPage title="Testimonials" endpoint="testimonials" testIdPrefix="testimonials"
    columns={[
      { key: "name", label: "Name" },
      { key: "course", label: "Course" },
      { key: "rating", label: "Rating" },
    ]}
    fields={[
      { name: "name", label: "Student name", type: "text", required: true },
      { name: "role", label: "Current role", type: "text" },
      { name: "course", label: "Course taken", type: "text", required: true },
      { name: "rating", label: "Rating (1-5)", type: "number", default: 5 },
      { name: "image", label: "Photo URL", type: "url" },
      { name: "review", label: "Review", type: "textarea", required: true },
    ]}
  />;
}

export function AdminFAQs() {
  return <AdminCrudPage title="FAQs" endpoint="faqs" testIdPrefix="faqs"
    columns={[
      { key: "question", label: "Question" },
      { key: "order", label: "Order" },
    ]}
    fields={[
      { name: "question", label: "Question", type: "text", required: true },
      { name: "answer", label: "Answer", type: "textarea", required: true },
      { name: "order", label: "Display order", type: "number", default: 0 },
      { name: "category", label: "Category", type: "text", default: "General" },
    ]}
  />;
}

export function AdminGallery() {
  return <AdminCrudPage title="Gallery" endpoint="gallery" testIdPrefix="gallery"
    columns={[
      { key: "title", label: "Title" },
      { key: "type", label: "Type" },
      { key: "category", label: "Category" },
      { key: "image", label: "Preview", render: (i) => i.image ? <img src={i.image} alt="" className="w-16 h-10 object-cover rounded" /> : "-" },
    ]}
    fields={[
      { name: "title", label: "Title", type: "text", required: true },
      { name: "type", label: "Type", type: "select", options: ["photo", "instagram_post", "instagram_reel", "youtube_video"], default: "photo" },
      { name: "image", label: "Thumbnail image URL", type: "url", required: true },
      { name: "video_url", label: "Video / Instagram post URL (for reels & videos)", type: "url" },
      { name: "caption", label: "Caption", type: "textarea", rows: 2 },
      { name: "category", label: "Category", type: "text", default: "General" },
      { name: "posted_at", label: "Posted date (YYYY-MM-DD)", type: "text" },
      { name: "featured", label: "Featured", type: "checkbox" },
      { name: "order", label: "Order", type: "number", default: 0 },
    ]}
  />;
}

export function AdminEvents() {
  return <AdminCrudPage title="Events" endpoint="events" testIdPrefix="events"
    columns={[
      { key: "title", label: "Title" },
      { key: "date", label: "Date" },
      { key: "location", label: "Location" },
    ]}
    fields={[
      { name: "title", label: "Title", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea", required: true },
      { name: "date", label: "Date", type: "text", required: true, placeholder: "e.g. 15 March 2026" },
      { name: "location", label: "Location", type: "text" },
      { name: "image", label: "Image URL", type: "url" },
    ]}
  />;
}

export function AdminTrainers() {
  return <AdminCrudPage title="Trainers" endpoint="trainers" testIdPrefix="trainers"
    columns={[
      { key: "name", label: "Name" },
      { key: "role", label: "Role" },
      { key: "order", label: "Order" },
    ]}
    fields={[
      { name: "name", label: "Name", type: "text", required: true },
      { name: "role", label: "Role / Designation", type: "text", required: true },
      { name: "image", label: "Photo URL", type: "url" },
      { name: "bio", label: "Bio", type: "textarea", rows: 4 },
      { name: "expertise", label: "Expertise (comma-separated)", type: "array-text" },
      { name: "linkedin", label: "LinkedIn URL", type: "url" },
      { name: "order", label: "Display order", type: "number", default: 0 },
    ]}
  />;
}

export function AdminSlides() {
  return <AdminCrudPage title="Hero Slides" endpoint="slides" testIdPrefix="slides"
    columns={[
      { key: "heading", label: "Heading" },
      { key: "order", label: "Order" },
      { key: "published", label: "Published", render: (i) => i.published ? "Yes" : "No" },
    ]}
    fields={[
      { name: "heading", label: "Heading", type: "text", required: true },
      { name: "subheading", label: "Subheading (badge)", type: "text" },
      { name: "description", label: "Description", type: "textarea", rows: 3 },
      { name: "cta_text", label: "Primary CTA text", type: "text" },
      { name: "cta_link", label: "Primary CTA link", type: "url" },
      { name: "secondary_cta_text", label: "Secondary CTA text", type: "text" },
      { name: "secondary_cta_link", label: "Secondary CTA link (URL or /path)", type: "text" },
      { name: "image", label: "Desktop image URL", type: "url" },
      { name: "mobile_image", label: "Mobile image URL", type: "url" },
      { name: "video_url", label: "Video URL (optional)", type: "url" },
      { name: "order", label: "Display order", type: "number", default: 0 },
      { name: "published", label: "Published", type: "checkbox", default: true },
    ]}
  />;
}
